import { localStorage } from 'dibs-browser-storage';
import { trackEvent } from 'dibs-tracking';

import {
    PDP_TRADE_ON_APPROVAL_VIEW_COUNT_STORAGE_KEY,
    PDP_TRADE_ON_APPROVAL_COACHMARK_TOOLTIP_DISMISSED,
    PDP_TRADE_ON_APPROVAL_COACHMARK_TOOLTIP_MAX_VIEWS,
} from './constants';

export const getPdpCoachmarkViews = () =>
    localStorage.getItem(PDP_TRADE_ON_APPROVAL_VIEW_COUNT_STORAGE_KEY) || 0;

export const pdpCoachmarkMaxViewsExceeded = () =>
    getPdpCoachmarkViews() >= PDP_TRADE_ON_APPROVAL_COACHMARK_TOOLTIP_MAX_VIEWS;

export const getPdpTooltipDismissed = () =>
    !!localStorage.getItem(PDP_TRADE_ON_APPROVAL_COACHMARK_TOOLTIP_DISMISSED);

export const logCoachmarkView = () => {
    const coachmarkViews = getPdpCoachmarkViews();
    localStorage.setItem(PDP_TRADE_ON_APPROVAL_VIEW_COUNT_STORAGE_KEY, coachmarkViews + 1);
    trackEvent({
        action: 'coachmark displayed',
        category: 'request item on approval',
        label: 'pdp',
    });
};

export const logPdpTooltipDismissal = () => {
    localStorage.setItem(PDP_TRADE_ON_APPROVAL_COACHMARK_TOOLTIP_DISMISSED, true);
    trackEvent({
        action: 'close button clicked',
        category: 'request item on approval',
        label: 'pdp',
    });
};

export const trackPdpTooltipView = () => {
    trackEvent({
        action: 'tooltip displayed',
        category: 'request item on approval',
        label: 'pdp',
    });
};
